import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Grid,
  Menu,
  MenuItem,
  Button,
  useTheme,
  ListItemIcon,
  ListItemText,
  Tabs,
  Tab,
  tabsClasses,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import {
  HDotsIcon,
  AdminPaypalIcon,
  AdminStripeIcon,
  AdminMasterIcon,
  AdminUnionIcon,
  AdminPayonerIcon,
  DollarIcon,
} from "../../../Svg";
import { makeStyles } from "@mui/styles";
import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import { AdminFormModal } from "../../../components";
import { headersGet, headersPost } from "../../../Services/API";
import { AdminUrls, domain } from "../../../Services/Routes/API";
import { MainRoutes } from "../../../Services/Routes/App";
import { GATEWAY_ENUM } from "../../../Services/Enums";

const PaymentGatewaysListing = () => {
  const payments = [
    { svg: <AdminPaypalIcon /> },
    { svg: <AdminStripeIcon /> },
    { svg: <AdminMasterIcon /> },
    { svg: <AdminUnionIcon /> },
    { svg: <AdminPayonerIcon /> },
  ];
  const theme = useTheme();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [updatePaymentMethodModal, setUpdatePaymentMethodUserModal] =
    useState(false);
  const [paymentGatways, setPaymentGatways] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [paymentGatewayRow, setPaymentGatewayRow] = useState(null);
  const [tabValue, setTabValue] = useState("un_archived_payment_gateways");
  const [categorizedGateWays, setCategorizedGateWays] = useState({});

  const updatePaymentGateway = (item) => {
    setPaymentGatewayRow(item);
    setUpdatePaymentMethodUserModal(true);
  };

  const userModalHandlerClose = () => {
    setUpdatePaymentMethodUserModal(false);
  };

  const useStyles = makeStyles({
    muiPaperShadowNone: {
      "& .MuiPaper-root": {
        boxShadow: "0px 3px 4px 0px rgb(30 63 138 / 3%)",
        minWidth: "100px",
      },
    },
  });

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClosee = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  // Add Payment Method Modal

  const Form_Modal_List_For_Add_Payment_Method = [
    {
      formKey: "payment_gateway",
      name: "bank_name",
      label: "Bank",
      value: paymentGatewayRow?.bank_name || "",
      style: { paddingY: 0.5, fontSize: 4 },
    },

    {
      formKey: "payment_gateway",
      name: "main_type",
      label: "Gateway",
      type: "select",
      value: paymentGatewayRow?.main_type || "",
      options: GATEWAY_ENUM,
      style: { paddingY: 0.5, fontSize: 4 },
    },
    {
      formKey: "payment_gateway",
      name: "client_secret",
      label: "Client Secret Key",
      value: paymentGatewayRow?.client_secret || "",
      style: { paddingY: 0.5, fontSize: 4 },
    },
    {
      formKey: "payment_gateway",
      name: "client_id",
      label: "Client Id",
      value: paymentGatewayRow?.client_id || "",
      style: { paddingY: 0.5, fontSize: 4 },
    },
    {
      formKey: "payment_gateway",
      name: "monthly_limit",
      label: "Monthly Transaction Limit",
      value: paymentGatewayRow?.monthly_limit || "",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },
    {
      formKey: "payment_gateway",
      name: "daily_limit",
      label: "Daily Transaction Limit",
      value: paymentGatewayRow?.daily_limit || "",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },

    {
      formKey: "payment_gateway",
      name: "average_ticket",
      label: "Avg Transaction Limit",
      value: paymentGatewayRow?.average_ticket || "",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },
    {
      formKey: "payment_gateway",
      name: "monthly_service_fee",
      label: "Service Fee",
      value: paymentGatewayRow?.monthly_service_fee || "",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },
    {
      formKey: "payment_gateway",
      value: paymentGatewayRow?.is_archived,
      type: "switch",
      name: "is_archived",
      label: "Active & Inactive",
      // status: true,
      handleChange: (e) => {},
    },
    {
      formKey: "payment_gateway",
      text: "Upload Logo",
      type: "file",
      name: "logo",
      // value: paymentGatewayRow?.logo.fil || "",
      style: {
        backgroundColor: "#FFA361",
        width: "40%",
        borderRadius: "1",
        padding: "1.5",
      },
    },
  ];

  const Form_Modal_Button_For_Add_Payment_Method = [
    {
      formKey: "payment_gateway",
      text: "Update",
      name: "update_payment_gateway",
      type: "submit",
      style: {
        backgroundColor: "#11A1EC",
        width: "100%",
        borderRadius: "1",
        padding: "1.5",
        marginBottom: "1rem",
      },
    },
  ];

  const handleTabsChange = (event, newValue) => {
    setPaymentGatways(categorizedGateWays?.[newValue]);
    setTabValue(newValue);
  };

  const getPaymentGatewaysListing = () => {
    setOpen(true);
    headersGet(AdminUrls.GET_PAYMENT_GATEWAYS_LISTING)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setCategorizedGateWays(res?.data?.categorized_payment_gateways);
          setOpen(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  useEffect(() => {
    getPaymentGatewaysListing();
  }, []);
  useEffect(() => {
    setTabValue("un_archived_payment_gateways");
    setPaymentGatways(categorizedGateWays?.un_archived_payment_gateways);
  }, [categorizedGateWays]);

  const updatePaymentGatewayHandler = (data) => {
    setOpen(true);
    headersPost(AdminUrls?.UPDATE_PAYMENT_GATEWAY, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setUpdatePaymentMethodUserModal(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  const classes = useStyles();
  return (
    <Box mt={6}>
      <Box sx={{ width: "100%", backgroundColor: "white", marginBottom: 2 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabsChange}
          variant="scrollable"
          //   scrollButtons
          sx={{
            [`& .${tabsClasses.scrollButtons}`]: {
              "&.Mui-disabled": { opacity: 0.3 },
            },
          }}
        >
          <Tab label="Active" value="un_archived_payment_gateways" />
          <Tab label="Inactive" value="archived_payment_gateways" />
        </Tabs>
      </Box>

      <Grid container spacing={2}>
        {paymentGatways?.map((row, index) => (
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <Paper sx={{ paddingBottom: 3 }}>
              <Box display={"flex"} justifyContent={"right"}>
                {" "}
                <Button
                  // id={`basic-button-${row?.id}`}
                  // aria-haspopup="true"
                  onClick={() => {
                    updatePaymentGateway(row);
                  }}
                  sx={{
                    borderRadius: 1,
                    minWidth: 0,
                    backgroundColor: "transparent",
                    padding: 1,
                    color: "#828282",
                  }}
                >
                  <EditIcon fontSize="small" />
                </Button>
                {/* <Menu
                  id={`basic-menu-${row?.id}`}
                  anchorEl={anchorEl}
                  open={anchorEl?.id === `basic-button-${row?.id}`}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  className={classes.muiPaperShadowNone}
                >
                  <MenuItem>
                    <ListItemIcon>
                      {" "}
                      <EditIcon />
                    </ListItemIcon>
                    <ListItemText
                      onClick={() => {
                        updatePaymentGateway(row);
                      }}
                    >
                      Edit
                    </ListItemText>
                  </MenuItem> */}
                {/* {tabValue === "un_archived_payment_gateways" && (
                    <MenuItem>
                      <ListItemIcon>
                        {" "}
                        <SyncAltIcon />
                      </ListItemIcon>
                      <ListItemText>Inactive</ListItemText>
                    </MenuItem>
                  )} */}
                {/* </Menu> */}
              </Box>
              <Box display={"flex"} justifyContent={"center"} minHeight={220}>
                {" "}
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  justifyContent={"center"}
                >
                  <img
                    src={domain + row?.logo}
                    alt={"logo"}
                    height={150}
                    width={150}
                  />
                  {/* {domain + row?.logo} */}
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
      <AdminFormModal
        open={updatePaymentMethodModal}
        onClose={userModalHandlerClose}
        MainHeading={"Update Payment Gateway"}
        TextFieldArray={Form_Modal_List_For_Add_Payment_Method}
        ButtonsArray={Form_Modal_Button_For_Add_Payment_Method}
        initialFormData={{
          payment_gateway: {
            id: paymentGatewayRow?.id,
          },
        }}
        onSubmit={updatePaymentGatewayHandler}
      />
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClosee}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClosee} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default PaymentGatewaysListing;
